<app-report-header
  crumbLabel="ATED Calculator"
  (download)="printScreen()"
  (recalculate)="startagain()">
</app-report-header>

<div class="rpt-page" id="contentToConvert">

  <!-- ── Masthead ── -->
  <div class="rpt-wrap rpt-masthead">
    <div class="rpt-masthead__eyebrow">Annual Tax on Enveloped Dwellings</div>
    <h1 class="rpt-masthead__title">ATED Liability — £{{calcData?.PropertyValue | number:'1.0-0'}} Property</h1>
    <p class="rpt-masthead__subtitle">
      Annual Tax on Enveloped Dwellings charge for a property held within a corporate body or partnership.
    </p>
    <div class="rpt-masthead__meta">
      <span class="rpt-meta-pill">Property Value <strong>£{{calcData?.PropertyValue | number:'1.0-0'}}</strong></span>
      <span class="rpt-meta-pill">Report Date <strong>{{validation.getCurrentDateWithSpecificFormat()}}</strong></span>
      <span class="rpt-meta-pill rpt-meta-pill--accent">Annual Charge <strong>{{atedchargevalue}}</strong></span>
    </div>
  </div>

  <!-- ── §01 KPI Section ── -->
  <section class="rpt-wrap rpt-section">
    <div class="rpt-section__head">
      <div>
        <div class="rpt-section__num">01 · Results</div>
        <h2 class="rpt-section__title">Annual ATED charge</h2>
        <p class="rpt-section__sub">The annual charge due for a property enveloped in a corporate body.</p>
      </div>
    </div>

    <div class="rpt-kpi-strip">
      <!-- Hero: Annual ATED Charge -->
      <div class="rpt-kpi-hero">
        <div class="rpt-kpi-hero__eyebrow">Annual ATED Charge</div>
        <div class="rpt-kpi-hero__body">
          <div class="rpt-kpi-hero__value">{{atedchargevalue}}</div>
          <div class="rpt-kpi-hero__label">Annual Tax on Enveloped Dwellings</div>
        </div>
        <p class="rpt-kpi-hero__caption">
          Annual ATED charge for a property valued at £{{calcData?.PropertyValue | number:'1.0-0'}} held within a corporate envelope.
        </p>
      </div>

      <!-- Side: Property Value -->
      <div class="rpt-kpi-side rpt-kpi-side--1">
        <div class="rpt-kpi-card">
          <div class="rpt-kpi-card__label">Property Value</div>
          <div class="rpt-kpi-card__value">£{{calcData?.PropertyValue | number:'1.0-0'}}</div>
          <div class="rpt-kpi-card__foot">Enveloped in a corporate body</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ── §02 Assumptions ── -->
  <section class="rpt-wrap rpt-section">
    <div class="rpt-section__head">
      <div>
        <div class="rpt-section__num">02 · Inputs</div>
        <h2 class="rpt-section__title">Your assumptions</h2>
      </div>
    </div>
    <div class="rpt-card">
      <div class="rpt-card__body">
        <div class="rpt-arow">
          <span class="rpt-arow__key">Property Value</span>
          <span class="rpt-arow__val">£{{calcData?.PropertyValue | number:'1.0-0'}}</span>
        </div>
        <div class="rpt-arow">
          <span class="rpt-arow__key">Annual ATED Charge</span>
          <span class="rpt-arow__val rpt-arow__val--accent">{{atedchargevalue}}</span>
        </div>
        <div class="rpt-arow">
          <span class="rpt-arow__key">Report Date</span>
          <span class="rpt-arow__val">{{validation.getCurrentDateWithSpecificFormat()}}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- ── §03 ATED Band Reference ── -->
  <section class="rpt-wrap rpt-section">
    <div class="rpt-section__head">
      <div>
        <div class="rpt-section__num">03 · Reference</div>
        <h2 class="rpt-section__title">ATED band reference</h2>
        <p class="rpt-section__sub">Annual charges by property value band (2026–27). Your applicable band is highlighted.</p>
      </div>
    </div>
    <div class="rpt-card">
      <div class="rpt-tbl-wrap">
        <table class="rpt-tbl">
          <thead>
            <tr>
              <th>Property Value Band</th>
              <th style="text-align:right">Annual Charge</th>
            </tr>
          </thead>
          <tbody>
            <tr [class.rpt-tbl__row--active]="calcData?.PropertyValue >= 500000 && calcData?.PropertyValue < 1000000">
              <td class="rpt-tbl__key">£500,001 – £1,000,000</td>
              <td class="rpt-tbl__val">£4,400</td>
            </tr>
            <tr [class.rpt-tbl__row--active]="calcData?.PropertyValue >= 1000000 && calcData?.PropertyValue < 2000000">
              <td class="rpt-tbl__key">£1,000,001 – £2,000,000</td>
              <td class="rpt-tbl__val">£9,000</td>
            </tr>
            <tr [class.rpt-tbl__row--active]="calcData?.PropertyValue >= 2000000 && calcData?.PropertyValue < 5000000">
              <td class="rpt-tbl__key">£2,000,001 – £5,000,000</td>
              <td class="rpt-tbl__val">£30,550</td>
            </tr>
            <tr [class.rpt-tbl__row--active]="calcData?.PropertyValue >= 5000000 && calcData?.PropertyValue < 10000000">
              <td class="rpt-tbl__key">£5,000,001 – £10,000,000</td>
              <td class="rpt-tbl__val">£71,500</td>
            </tr>
            <tr [class.rpt-tbl__row--active]="calcData?.PropertyValue >= 10000000 && calcData?.PropertyValue < 20000000">
              <td class="rpt-tbl__key">£10,000,001 – £20,000,000</td>
              <td class="rpt-tbl__val">£143,550</td>
            </tr>
            <tr [class.rpt-tbl__row--active]="calcData?.PropertyValue >= 20000000">
              <td class="rpt-tbl__key">Over £20,000,000</td>
              <td class="rpt-tbl__val">£287,500</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

</div>

<app-report-footer
  [today]="today"
  (download)="printScreen()"
  (recalculate)="startagain()">
</app-report-footer>
